/* eslint-disable unicorn/filename-case */
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import lookupValidator from 'ember-changeset-validations';
import type { TypedBufferedChangeset } from 'ember-form-changeset-validations';
import type { ContactDTO } from 'frontend/services/contact';
import formscontactValidation from 'frontend/validations/contact';
import type ContactService from 'frontend/services/contact';
import { tracked } from 'tracked-built-ins';
import type SessionService from 'frontend/services/session';
import { action } from '@ember/object';

interface PagesContactIndexArgs {}

export default class PagesContactIndex extends Component<PagesContactIndexArgs> {
  @service declare router: RouterService;
  @service declare contact: ContactService;
  @service declare session: SessionService;
  @tracked changeset: TypedBufferedChangeset<ContactDTO> | undefined;

  constructor(owner: unknown, args: PagesContactIndexArgs) {
    super(owner, args);
    this.changeset = this.session.isAuthenticated
      ? this.contact.currentUserChangeset()
      : this.contact.emptyChangeset();
    lookupValidator(formscontactValidation), formscontactValidation;
  }

  @action
  async saveContact(changeset: TypedBufferedChangeset<ContactDTO>) {
    await this.contact.saveChangeset(changeset);
  }
}
